import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

type CreateFromTemplateAnalyticsEventParams = {
	type: 'sendScreenEvent' | 'sendTrackEvent' | 'sendUIEvent';
	action: string;
	actionSubject: string;
	actionSubjectId?: string;
	attributes?: Record<string, any>;
};

type CreateFromTemplateAnalyticsEvent = (params: CreateFromTemplateAnalyticsEventParams) => void;

export const useCreateFromTemplateAnalyticsEvents = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendCreateFromTemplateAnalyticsEvent: CreateFromTemplateAnalyticsEvent = useCallback(
		({ type, action, actionSubject, actionSubjectId, attributes }) => {
			createAnalyticsEvent({
				type,
				data: {
					source: 'homeOnboarding',
					action,
					actionSubject,
					actionSubjectId,
					attributes,
				},
			}).fire();
		},
		[createAnalyticsEvent],
	);

	return sendCreateFromTemplateAnalyticsEvent;
};
